<div class="skeleton skeleton-chip-id"></div>
<div class="skeleton skeleton-chip-status"></div>
<div class="skeleton skeleton-meta-date"></div>
